import { connect } from 'react-redux';
import { loadTranslations } from '../store/translationSlice';

const mapStateToProps = (state) => ({
	translations: state.translation.translations,
	currentLanguage: state.translation.currentLanguage,
});

const mapDispatchToProps = (dispatch) => ({
	changeLanguage: (language) => 
	dispatch(loadTranslations(language)),
});

const t = (translations, key, params = {}) => {
	const keys = key.split('.');
	let value = translations;
	
	for (const k of keys) {
		if (value[k] === undefined) {
			return ""; // Return empty string if not translation found
		}
		value = value[k];
	}

	if (typeof value !== 'string') {
		return '';
	}

	return Object.entries(params).reduce(
		(result, [paramKey, paramValue]) =>
			result.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(paramValue)),
		value,
	);
};

export const withTranslation = (WrappedComponent) => {
	return connect(mapStateToProps, mapDispatchToProps)((props) => {
		const translate = (key, params) => t(props.translations, key, params);
		return ( <WrappedComponent {...props} t={translate} />);
	});
};
